// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1bnlT","footer":"ModalFilter_footer__2bbuQ"};